// @flow
import React from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import type {AbMode} from '../entities'

type Props = {
  width: string,
  abMode: AbMode,
  onChange: (width:string, abMode:AbMode) => void
}

type State = {
  active: boolean,
  width: string,
  abMode: AbMode
}

export default class Input extends React.Component<Props,State> {

  // $FlowFixMe
  // input = React.createRef()

  state = {
    active: false, 
    width: this.props.width,
    abMode: this.props.abMode
  }

  // componentDidUpdate(){
  //   if(!this.state.active) return
  //   if(!this.input.current) return
  //   this.input.current.focus()
  // }

  handleWidthChange = (e:*) => {
    this.setState({ width: e.target.value })
  }

  handleAbModeChange = (e:*) => {
    this.setState({ abMode: e.target.value })
  }

  update = () => {
    this.setState({ active: false })
    this.props.onChange(this.state.width, this.state.abMode)
  }

  render () {
    let {active, width, abMode} = this.state
    return (
      <Wrapper abMode={this.state.abMode}>
        <Text onClick={() => this.setState({active: true})}>{this.props.width}</Text>
        {active && ReactDOM.createPortal(
          <Box>
            <div className='close' onClick={this.update}>X</div>
            <div className='content'>
              <div className='row'>
                <div className='label'>Width</div>
                <div className='value'>
                  <input type='text' value={width} onChange={this.handleWidthChange}/>
                </div>
              </div>
              <div className='row'>
                <div className='label'>Test-Mode</div>
                <div className='value'>
                  <select value={abMode} onChange={this.handleAbModeChange}>
                    <option value='none'>none</option>
                    <option value='a'>a</option>
                    <option value='b'>b</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='close-button' onClick={this.update}>
              Close
            </div>
          </Box>
        // $FlowFixMe
        ,document.getElementById('portal'))}
      </Wrapper>
    )
  }

}

const Wrapper = styled.div`
  font-size: 14px;
  width: 100%;
  height: 100%;

  ${props => props.abMode === 'a' && `
    background: #8bc34a;
  `}

  ${props => props.abMode === 'b' && `
    background: #ffc107;
  `}
`

const Text = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const Box = styled.div`
  position: fixed;
  left: 25%;
  right: 25%;
  top: 150px;
  width: 50%;
  background: white;
  border: 1px solid grey;

  > .close {
    height: 30px;
    width: 100%;
    text-align: right;
    padding-top: 8px;
    color: white;
    padding-right: 8px;
    background: rgb(89,111,121);
    cursor: pointer;
  }

  > .content {
    padding: 10px;

    > .row {
      width: 100%;
      display: flex;
      margin-bottom: 10px;

      > .label {flex:1; font-size: 20px;}
      > .value {flex:1}

      select, input {
        width: 122px;
        font-size: 20px;
      }
    }
  }

  > .close-button {
    margin: 20px auto;
    width: 200px;
    background: rgb(89,111,121);
    color: white;
    padding: 10px;
    text-align: center;
    cursor: pointer;
  }
`


// WEBPACK FOOTER //
// ./src/components/Width.js